(ns manatee.ui.templates
  (:require [manatee.components.header.container :as header]
            [rothko.layout.component :refer [layout]]))

(defn single-column
  [{:keys [class]} {:keys [footer main]}]
  [layout {:appearance #{:container}
           :class class}
   [header/container]
   [layout {:appearance #{:main}
            :element :main}
    [main]]
   [footer]])
